<template>
  <div id="banner" style="padding: 0px !important;">
    <div
      style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
      v-if="model.length"
      class="banner-image"
      :style="{
        'background-image': 'url(' + model + ')',
        'background-size': 'contain'
      }"
    ></div>
    <div class="full-width align-hor center-hor" v-else>
      <div class="wrapper animate radius-5 banner-image full-width"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: String
  }
};
</script>

<style>
#banners {
  min-height: 170px;
  height: auto;
  margin-top: 70px;
  margin-bottom: 7px;
}
.banner-image {
  height: 160px;
  /* width: 100vw; */
}
</style>
